import React from 'react';
import platform from 'platform';
import AppContext from '../../AppContext';
import localizedStrings from '../Auth/localization';
import Icon from '@projeccions-pdc/react-icon';
import playStore from './Images/play-store.png';
import appleStore from './Images/apple-store.png';

export function getDownloadLink() {
    let appContext = new AppContext();
    let platformConfig = appContext.getPlatformConfig();
    if (platformConfig === undefined) {
        return undefined;
    }
    let links = platformConfig.appURLs;
    let currentPlatform = platform.os.toString().toLowerCase();
    //console.log(links, currentPlatform);
    if (links !== undefined) {
        if (currentPlatform.indexOf('windows') !== -1) {
            return links.windows;
        } else if (currentPlatform.indexOf('os x') !== -1) {
            return links.mac;
        } else if (currentPlatform.indexOf('ios') !== -1) {
            return links.ios;
        } else if (currentPlatform.indexOf('android') !== -1) {
            return links.android;
        } else if (currentPlatform.indexOf('ubuntu') !== -1 ||
            currentPlatform.indexOf('debian') !== -1 ||
            currentPlatform.indexOf('fedora') !== -1 ||
            currentPlatform.indexOf('red hat') !== -1 ||
            currentPlatform.indexOf('redhat') !== -1 ||
            currentPlatform.indexOf('suse') !== -1 ||
            currentPlatform.indexOf('centos') !== -1 ||
            currentPlatform.indexOf('cent os') !== -1) {
            return links.linux;
        }
    } else {
        return undefined;
    }
}

export function getDownloadBadge(handleDownloadApp) {
    let appContext = new AppContext();
    let platformConfig = appContext.getPlatformConfig();
    if (platformConfig === undefined) {
        return undefined;
    }
    let links = platformConfig.appURLs;
    let currentPlatform = platform.os.toString().toLowerCase();
    //console.log(links, currentPlatform);
    if (links !== undefined) {
        if (currentPlatform.indexOf('ios') !== -1) {
            return (
                <img src={appleStore} alt='Apple Store'
                    onClick={() => handleDownloadApp(links.ios)}
                    style={{
                        width: '130px',
                        height: 'auto',
                        cursor: 'pointer',
                    }} />
            );
        } else if (currentPlatform.indexOf('android') !== -1) {
            return (
                <img src={playStore} alt='Play Store'
                    onClick={() => handleDownloadApp(links.android)}
                    style={{
                        width: '130px',
                        height: 'auto',
                        cursor: 'pointer',
                    }} />
            );
        } else if (
            currentPlatform.indexOf('os x') !== -1 ||
            currentPlatform.indexOf('windows') !== -1 ||
            currentPlatform.indexOf('ubuntu') !== -1 ||
            currentPlatform.indexOf('debian') !== -1 ||
            currentPlatform.indexOf('fedora') !== -1 ||
            currentPlatform.indexOf('red hat') !== -1 ||
            currentPlatform.indexOf('redhat') !== -1 ||
            currentPlatform.indexOf('suse') !== -1 ||
            currentPlatform.indexOf('centos') !== -1 ||
            currentPlatform.indexOf('cent os') !== -1) {
            let link;
            if (currentPlatform.indexOf('windows') !== -1) {
                link = links.windows;
            } else if (currentPlatform.indexOf('os x') !== -1) {
                link = links.mac;
            } else if (currentPlatform.indexOf('ubuntu') !== -1 ||
                currentPlatform.indexOf('debian') !== -1 ||
                currentPlatform.indexOf('fedora') !== -1 ||
                currentPlatform.indexOf('red hat') !== -1 ||
                currentPlatform.indexOf('redhat') !== -1 ||
                currentPlatform.indexOf('suse') !== -1 ||
                currentPlatform.indexOf('centos') !== -1 ||
                currentPlatform.indexOf('cent os') !== -1) {
                link = links.linux;
            }
            return (
                <div
                    style={{
                        display: 'inline-block',
                        cursor: 'pointer',
                        textAlign: 'left',
                        backgroundColor: '#000',
                        border: '1px solid rgb(165,165,165)',
                        color: '#fff',
                        padding: '10px',
                        borderRadius: '10px',
                        height: '20px',
                        fontSize: '12px'
                    }}
                    onClick={() => handleDownloadApp(link)}
                >
                    <Icon name='md-devices-other' primaryColor='#fff' size={'25px'} />
                    <span style={{ marginLeft: '5px' }}>
                        {localizedStrings.download}
                    </span>
                </div>
            );

        }
    } else {
        return undefined;
    }
}

export function getPlatform() {
    return platform.os.family;
}